import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IBinderListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineBinder;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class BinderLista extends BaseComponent<Glob.IRouteGlobaleProps, IBinderListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreBinder = this.OnErroreBinder.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si pu� scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [7], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_Binder", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("CodiceBinder", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("AnagDa", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("AnagA", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("DataEffetto", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 5:
                                this.OnOrdinamento("DataFine", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 6:
                                this.OnOrdinamento("DataStipula", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineBinder, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={8} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr key={dato.ID_Binder}>
                        <td className="TextCenter"><a href="#" className="arrow" onClick={(e) => { e.preventDefault(); this.props.history.push("/binder/" + dato.ID_Binder) }}>
                            {dato.ID_Binder}
                        </a></td>
                        <td className="TextRight">{dato.CodiceBinder}</td>
                        <td className="TextLeft">{dato.AnagDa}</td>
                        <td className="TextLeft">{dato.AnagA}</td>
                        <td className="TextCenter">{Trad.Trad(dato.DataEffetto || "")}</td>
                        <td className="TextCenter">{Trad.Trad(dato.DataFine || "")}</td>
                        <td className="TextCenter">{Trad.Trad(dato.DataStipula || "")}</td>
                        <td className="TextCenter">
                            <a href="#" className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/binder/" + dato.ID_Binder) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>
                )}
            </tbody>;
        }
    }

    private OnErroreBinder(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={8}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        if (!this.ControlloAutorizzazione("BinderController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-handshake"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Binder")}</h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                            <NavLink to="/binder/0" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                        <div className="col-lg-4 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_Binder"] || ""} name="ParametriUtente[ID_Binder]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Codice binder")}</label>
                        <div className="col-lg-4 form-control-plaintext">
                            <input onChange={(e) => this.OnChange(e)} type="text" value={this.state.ParametriUtente["CodiceBinder"] || ""} name="ParametriUtente[CodiceBinder]" className="form-control kt-input" placeholder={Trad.Trad("Codice binder")} />
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Da")}</label>
                        <div className="col-lg-4 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ParametriUtente[ID_AnagDa]" ID_ChiaveString={this.state.ParametriUtente["ID_AnagDa"] || ""} OnAggiorna={this.OnChange} TradValori />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("A")}</label>
                        <div className="col-lg-4 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ParametriUtente[ID_AnagA]" ID_ChiaveString={this.state.ParametriUtente["ID_AnagA"] || ""} OnAggiorna={this.OnChange} TradValori />
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                        <div className="row">
                            <div className="col kt-form__actions kt-form__actions--center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th scope="row" className="TextCenter">ID</th>
                            <th scope="row" className="TextRight">{Trad.Trad("Codice binder")}</th>
                            <th scope="row" className="TextLeft">{Trad.Trad("Da")}</th>
                            <th scope="row" className="TextLeft">{Trad.Trad("A")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Data effetto")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Data fine")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Data stipula")}</th>
                            <th data-field="edit" className="TextCenter">{Trad.Trad("Modifica")}</th>
                        </tr>
                    </thead>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/Binder/Ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreBinder} />
                </table>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/BinderLista.tsx